import { Button, Group, Modal, Stack, Text } from "@mantine/core";

import type { ConfirmModalProps } from "./type";

export default function ConfirmModal({
  opened,
  title,
  message,
  onConfirm,
  onClose,
  confirmLabel = "بله",
  cancelLabel = "خیر",
  loading,
}: ConfirmModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} centered={true}>
      <Stack>
        <Text size="sm">{message}</Text>

        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
